import { ReactNode } from 'react';
import classNames from 'classnames';

import { mobileBetslip as branding } from 'constants/branding';

import styles from './KeyboardButton.module.scss';

type KeyboardButtonProps = {
  children: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  shouldIgnoreBlurEvent?: boolean;
  className?: string;
};

const KeyboardButton = ({ children, onClick, disabled, shouldIgnoreBlurEvent, className }: KeyboardButtonProps) => {
  return (
    <button
      className={classNames(styles.button, className, branding.KEYBOARD_KEY, {
        [branding.DISABLED]: disabled
      })}
      disabled={disabled}
      onClick={onClick}
      onMouseDown={ev => shouldIgnoreBlurEvent && ev.preventDefault()}
    >
      {children}
    </button>
  );
};

export default KeyboardButton;
